import { arrayOf, bool, func, string } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import getInfoTooltip from '../../../generic/Tooltip/get-info-tooltip';
import withConfirm from '../../../generic/with-confirm';
import api from '../../../REST/api';
import withApiRequest from '../../../REST/with-api-request';
import HELP_TEXTS from '../../help-texts';

function PushToSAPButton({
  onRequest,
  onSuccess,
  disabled,
  loading,
  className,
  selectedInvoices,
}) {
  const isThereSelection = selectedInvoices && !!selectedInvoices.length;

  const createConfirmationButton = confirmationMessage =>
    withConfirm(confirmationMessage)(Button);

  const PushToSAPComponent = createConfirmationButton(
    isThereSelection
      ? 'Do you really want to push the selected approved invoices to SAP?'
      : 'Do you really want to push all approved invoices to SAP?',
  );

  return (
    <PushToSAPComponent
      color="primary"
      disabled={disabled || loading}
      className={className}
      onClick={
        () =>
          onRequest({ selectedInvoices }).then(onSuccess).catch(console.error) // eslint-disable-line no-console
      }
    >
      {selectedInvoices
        ? 'Push selected approved invoices to SAP'
        : 'Push all approved invoices to SAP'}
      {disabled &&
        getInfoTooltip(
          HELP_TEXTS,
          selectedInvoices ? 'selectInvoice' : 'export',
          'statusChanges',
        )}
    </PushToSAPComponent>
  );
}

PushToSAPButton.propTypes = {
  onRequest: func.isRequired,
  onSuccess: func.isRequired,
  loading: bool.isRequired,
  className: string,
  disabled: bool,
  selectedInvoices: arrayOf(string),
};

PushToSAPButton.defaultProps = {
  className: '',
  disabled: false,
  selectedInvoices: undefined,
};

export default withApiRequest({
  query: api.pushInvoicesToSAP,
  error: 'flash',
  successMessage: 'Approved invoices have been pushed to SAP.',
})(PushToSAPButton);
